module.exports = ".confirm-dialog {\n  min-width: 500px;\n  max-width: 700px; }\n"